import React from 'react';
import styled, { css, keyframes } from 'styled-components';

const hexagonAnimation = (props) => {
  return keyframes`
      from {
        opacity: ${props.opacity_from};
        transform: rotate(${props.rotation_from});

      }
      to  {
        opacity: ${props.opacity_to};
        transform: rotate(${props.rotation_to});
      }
  `;
};

const SVGStyle = styled.svg`
  width: 100%;
  z-index: 0;

  ${(props) => {
    if (props.isVisible) {
      if (!props.animation_enable) {
        return css`
          fill: ${props.color};
          filter: blur(${props.filter_blur});
          opacity: ${props.opacity_from};
          transform: rotate(${props.rotation_from});
        `;
      }
      return css`
        animation: ${hexagonAnimation(props)};
        animation-duration: ${props.time_animation};
        animation-iteration-count: ${props.interation_count};
        animation-direction: alternate;
        animation-timing-function: ease;
        animation-fill-mode: forwards;
        fill: ${props.color};
        filter: blur(${props.filter_blur});
      `;
    }
  }}
`;

const HexagonSVG = props => (
  <SVGStyle
    {...props}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500.92 440"
  >
    <path
      strokeMiterlimit="10"
      d="M364.15.5H136.77a22.62 22.62 0 0 0-19.56 11.29L3.53 208.71a22.55 22.55 0 0 0 0 22.58l113.68 196.92a22.62 22.62 0 0 0 19.56 11.29h227.38a22.59 22.59 0 0 0 19.56-11.29L497.4 231.29a22.6 22.6 0 0 0 0-22.58L383.71 11.79A22.59 22.59 0 0 0 364.15.5z"
    />
  </SVGStyle>
);

export default HexagonSVG;



// WEBPACK FOOTER //
// ./src/components/UI/Img/HexagonSVG/HexagonSVG.jsx